import { useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../hooks/useAuth';

export default function KeywordGapPage() {
  const [domains, setDomains] = useState(['', '', '']);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [tab, setTab] = useState('missing');
  const { updateCredits } = useAuth();

  function updateDomain(idx, val) {
    const newD = [...domains]; newD[idx] = val; setDomains(newD);
  }

  async function analyze() {
    const clean = domains.map(d => d.trim()).filter(Boolean);
    if (clean.length < 2) { setError('Enter at least 2 domains'); return; }
    if (loading) return;
    setError(''); setLoading(true); setData(null);
    try {
      const res = await api.post('/domain/keyword-gap', { domains: clean });
      setData(res.data.data);
      updateCredits(res.data.credits_remaining);
    } catch (e) { setError(e.response?.data?.error || 'Failed'); } finally { setLoading(false); }
  }

  return (
    <div className="fade-up">
      <div className="page-header">
        <h1 className="page-title">Keyword Gap</h1>
        <p className="page-sub">Compare up to 5 domains and find keywords they rank for but you don't · 5 credits</p>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 12 }}>
          {domains.map((d,i) => (
            <input key={i} className="input" placeholder={`Domain ${i+1} e.g. ${['nike.com','adidas.com','puma.com'][i]}`} value={d} onChange={e => updateDomain(i, e.target.value)} />
          ))}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-orange" onClick={analyze} disabled={loading}>{loading ? 'Comparing...' : 'Compare →'}</button>
          <button className="btn btn-white" onClick={() => setDomains([...domains, ''])} disabled={domains.length >= 5}>+ Add domain</button>
        </div>
        {error && <div style={{ marginTop: 10, color: '#FF3D57', fontSize: 13, background: '#FFEBEE', padding: '8px 12px', borderRadius: 6 }}>{error}</div>}
      </div>

      {loading && <div className="card"><div className="skeleton" style={{ height: 200 }} /></div>}

      {data && (
        <>
          <div className="metric-grid">
            <div className="card" style={{ margin: 0 }}><div className="metric-label">Total Keywords</div><div className="metric-value">{data.summary.totalKeywords}</div><div className="metric-sub">analyzed</div></div>
            <div className="card" style={{ margin: 0 }}><div className="metric-label">Shared</div><div className="metric-value">{data.summary.sharedKeywords}</div><div className="metric-sub">common to all</div></div>
            <div className="card" style={{ margin: 0 }}><div className="metric-label">Missing Opportunities</div><div className="metric-value" style={{ color: '#00C853' }}>{data.summary.missingOpportunities}</div><div className="metric-sub">you don't rank</div></div>
            <div className="card" style={{ margin: 0 }}><div className="metric-label">Weak Spots</div><div className="metric-value" style={{ color: '#FFAB00' }}>{data.summary.weakSpots}</div><div className="metric-sub">you rank lower</div></div>
          </div>

          <div className="card">
            <div className="tabs">
              <button className={`tab-btn ${tab === 'missing' ? 'active' : ''}`} onClick={() => setTab('missing')}>Missing ({data.gaps.missing.length})</button>
              <button className={`tab-btn ${tab === 'weak' ? 'active' : ''}`} onClick={() => setTab('weak')}>Weak ({data.gaps.weak.length})</button>
              <button className={`tab-btn ${tab === 'strong' ? 'active' : ''}`} onClick={() => setTab('strong')}>Strong ({data.gaps.strong.length})</button>
              <button className={`tab-btn ${tab === 'all' ? 'active' : ''}`} onClick={() => setTab('all')}>All Keywords</button>
            </div>

            <div className="table-wrap">
              <table className="table">
                <thead><tr><th>Keyword</th><th>Volume</th><th>KD</th>{data.domains.map(d => <th key={d}>{d}</th>)}</tr></thead>
                <tbody>
                  {(tab === 'missing' ? data.gaps.missing : tab === 'weak' ? data.gaps.weak : tab === 'strong' ? data.gaps.strong : data.keywords).slice(0, 50).map((k,i) => (
                    <tr key={i}>
                      <td style={{ fontWeight: 600 }}>{k.keyword}</td>
                      <td>{k.volume.toLocaleString()}</td>
                      <td>{k.kd}%</td>
                      {k.positions.map((pos, idx) => (
                        <td key={idx}>{pos ? <span className={`badge ${pos <= 10 ? 'badge-green' : pos <= 20 ? 'badge-yellow' : 'badge-gray'}`}>{pos}</span> : <span style={{ color: '#D1D5DB' }}>—</span>}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
